(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const main = root.querySelector('[data-nb-main]');
    const thumbs = [...root.querySelectorAll('[data-nb-thumb]')];
    const zoom = root.querySelector('[data-nb-zoom]');
    const dialog = root.querySelector('[data-nb-dialog]');
    const close = root.querySelector('[data-nb-close]');
    const sticky = root.querySelector('[data-nb-sticky]');
    const buy = root.querySelector('[data-nb-submit]');
    const stickyBuy = root.querySelector('[data-nb-sticky-submit]');
    let opener;
    const showPhoto = (thumb, index) => {
      main.srcset = thumb.dataset.srcset;
      main.src = thumb.dataset.full;
      main.alt = thumb.dataset.alt;
      thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      root.querySelector('[data-nb-count]').textContent = String(index + 1);
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showPhoto(thumb, index)));
    const movePhoto = direction => {
      const current = thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true');
      const index = (current + direction + thumbs.length) % thumbs.length;
      showPhoto(thumbs[index], index);
      thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    ['prev', 'next'].forEach((name, index) => {
      const control = root.querySelector(`[data-nb-${name}]`);
      if (!control) return;
      control.hidden = thumbs.length < 2;
      control.addEventListener('click', () => movePhoto(index ? 1 : -1));
    });
    const stage = root.querySelector('.nbp-stage');
    let touchStart;
    stage.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', event => {
      if (touchStart === undefined) return;
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 50) movePhoto(delta < 0 ? 1 : -1);
      touchStart = undefined;
    }, { passive: true });
    root.querySelector('.nbp-thumbs').addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      movePhoto(event.key === 'ArrowRight' ? 1 : -1);
      thumbs.find(thumb => thumb.getAttribute('aria-pressed') === 'true')?.focus();
    });
    let queued = false;
    const update = () => {
      queued = false;
      const menuOpen = document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open');
      const visible = buy.getBoundingClientRect().bottom < 0 && !dialog.open && !menuOpen;
      stickyBuy.disabled = buy.disabled;
      stickyBuy.textContent = buy.textContent;
      sticky.hidden = !visible;
      if (document.body.classList.contains('nb-pdp-sticky') !== visible) document.body.classList.toggle('nb-pdp-sticky', visible);
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    if (main && dialog && typeof dialog.showModal === 'function') {
      zoom.hidden = false;
      zoom.addEventListener('click', () => {
        opener = document.activeElement;
        const image = root.querySelector('[data-nb-full]');
        image.src = thumbs.find(thumb => thumb.getAttribute('aria-pressed') === 'true')?.dataset.full || main.src;
        image.alt = main.alt;
        root.querySelector('[data-nb-caption]').textContent = main.alt;
        dialog.showModal();
        close.focus();
        update();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('keydown', event => { if (event.key === 'Tab') { event.preventDefault(); close.focus(); } });
      dialog.addEventListener('close', () => { opener?.focus(); update(); });
    }
    const ready = root.dataset.ready === 'true';
    const form = root.querySelector('[data-nb-form]');
    form.addEventListener('submit', event => { if (!ready) event.preventDefault(); });
    const select = root.querySelector('[data-nb-variant]');
    const colourGroup = root.querySelector('[data-nb-colours]');
    const colours = [...root.querySelectorAll('[data-nb-colour]')];
    const quantityInput = root.querySelector('[data-nb-quantity]');
    const quantitySteps = [...root.querySelectorAll('[data-nb-quantity-step]')];
    const syncQuantity = () => {
      if (!quantityInput) return;
      const value = Math.max(1, Math.floor(Number(quantityInput.value) || 1));
      quantityInput.value = String(value);
      quantitySteps.forEach(button => { button.disabled = quantityInput.disabled || (button.dataset.nbQuantityStep === '-1' && value <= 1); });
    };
    if (quantityInput) {
      quantitySteps.forEach(button => button.addEventListener('click', () => {
        quantityInput.value = String(Math.max(1, Math.floor(Number(quantityInput.value) || 1) + Number(button.dataset.nbQuantityStep)));
        syncQuantity();
      }));
      quantityInput.addEventListener('input', () => { if (quantityInput.value !== '' && Number(quantityInput.value) < 1) syncQuantity(); });
      quantityInput.addEventListener('change', syncQuantity);
      quantityInput.addEventListener('blur', syncQuantity);
      form.addEventListener('submit', syncQuantity);
      syncQuantity();
    }
    const syncVariant = () => {
      const selected = select.selectedOptions[0];
      colours.forEach(colour => { colour.checked = colour.value === selected.value; });
      const colourName = root.querySelector('[data-nb-colour-name]');
      if (colourName) colourName.textContent = selected.dataset.photo;
      if (selected.dataset.photo) {
        const index = thumbs.findIndex(thumb => thumb.dataset.nbVariantPhoto === selected.dataset.photo);
        if (index !== -1) showPhoto(thumbs[index], index);
      }
      root.querySelector('[data-nb-sticky-price]').textContent = selected.dataset.price;
      if (!ready) { update(); return; }
      root.querySelector('[data-nb-price]').textContent = selected.dataset.price;
      root.querySelector('[data-nb-submit]').disabled = selected.dataset.available !== 'true';
      const quantity = root.querySelector('input[name=quantity]');
      quantity.disabled = selected.dataset.available !== 'true';
      if (quantity.closest('[data-nb-quantity-card]')) syncQuantity();
      else quantity.parentElement.hidden = quantity.disabled;
      const availability = root.querySelector('[data-nb-availability]');
      if (availability) availability.hidden = !quantity.disabled;
      buy.textContent = selected.dataset.available === 'true' ? stickyBuy.dataset.addLabel : stickyBuy.dataset.soldOutLabel;
      update();
      root.querySelector('[data-nb-sticky-price]').textContent = selected.dataset.price;
    };
    if (select) {
      select.addEventListener('change', syncVariant);
      if (colourGroup && colours.length) {
        colours.forEach(colour => colour.addEventListener('change', () => {
          if (!colour.checked) return;
          select.value = colour.value;
          syncVariant();
        }));
        colourGroup.hidden = false;
        root.querySelector('[data-nb-select-wrap]').hidden = true;
      }
      syncVariant();
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    update();
  };
  const scan = () => document.querySelectorAll('.nbp-compact[data-nb-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

